<div *ngIf="exam" class="cand-modal">
    <article class="cand-modal__overlay">
        <section class="cand-modal__content">
            <div class="cand-modal__titlebt">
                {{ exam.title | i18n }}
            </div>
            <div class="cand-modal__detailTitle">
                {{ exam.subtitle | i18n }}
            </div>
            <div class="cand-modal__box">
                <div *ngIf="exam.leftList">
                    <div *ngFor="let element of exam.leftList">{{ element | i18n }}</div>
                </div>
                <div *ngIf="exam.rightList">
                    <div *ngFor="let element of exam.rightList">{{ element | i18n }}</div>
                </div>
            </div>
            <footer class="recovery-form__footer">
                <button class="button button--primary cand-modal__buttonsize" type="button" (click)="handleClick()">
                    {{ 'documentselection.bloodtest.button.close' | i18n }}
                </button>
            </footer>

            <app-send-docs-by-post-component></app-send-docs-by-post-component>
        </section>
    </article>
    <div class="cand-modal__fade" ng-click="detailbloodtest.close()"></div>
</div>
